import { render, staticRenderFns } from "./new_account_page.vue?vue&type=template&id=38b2260a&scoped=true"
import script from "./new_account_page.vue?vue&type=script&lang=js"
export * from "./new_account_page.vue?vue&type=script&lang=js"
import style0 from "./new_account_page.vue?vue&type=style&index=0&id=38b2260a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b2260a",
  null
  
)

export default component.exports